<template>
  <div class="article-detail">
    <nav-header :activeIndex="3" />
    <main class="article-detail-content">
      <div class="article-detail-content-inner">
        <div class="article-detail-content-inner-title">
          <router-link :to="{name: 'home'}">首页</router-link>
          > <router-link :to="{name: 'home-article'}">圣诉文章</router-link> >
          <span>{{article && article.title}}</span></div>
        <div class="article-detail-content-inner-content">
          <div class="article-detail-content-inner-content-left" v-html="article && article.content"></div>
          <div :class="['article-detail-content-inner-content-right']" id="rightFixed">
            <div class="lawyer" v-if="lawyerList && lawyerList.length">
              <div class="title">
                <p>相关律师推荐</p>
                <router-link tag="span" :to="{name: 'home-lawyer', query: {expertField: article.type}}">更多</router-link>
              </div>
              <router-link tag="div" :to="{name: 'lawyer-detail', query:{lawyerId: item.lawyerId}}" class="content" v-for="(item, index) in lawyerList" :key="index">
                <img class="content-avatar" :src="item.avatar"/>
                <div class="content-msg">
                  <div class="content-msg-title">{{item.lawyerName}}</div>
                  <p>{{lawyerPositionFilter(item.lawyerPosition)}}</p>
                  <p>{{item.lawfirm}}</p>
                  <p class="help">在圣诉平台帮助了{{item.helper}}位用户</p>
                </div>
              </router-link>
            </div>
            <div class="article" v-if="articleList && articleList.length">
              <div class="title">
                <p>相关专业问题推荐</p>
                <router-link tag="span" :to="{name: 'home-article', query: {type: article.type}}">更多</router-link>
              </div>
              <ul class="content">
                <router-link tag="li" v-for="(item, index) in articleList"
                             :to="{name: 'article-detail', query: {id: item.id}}"
                             :key="index">{{item.title}}</router-link>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
  import api from './api'
  import NavHeader from '@/common-components/nav-header'
  export default {
    name: 'home-article',
    components: { NavHeader },
    data () {
      return {
        article: null,
        isFixed: false,
        type: '',
        pageIndex: 1,
        pageSize: 3,
        lawyerList: [],
        articleList: [],
        offsetTop: 0
      }
    },
    watch: {
      '$route.query': {
        handler: function (query) {
          this.getArticle(query.id).then(() => {
            this.getLawyerList()
            this.getArticleList()
          })
        },
        deep: true
      }
    },
    mounted () {
      if (this.$route.query.lawyerId) {
        api.getLawyerDetail(this.$route.query.lawyerId).then(res => {
          this.article = {}
          this.article.content = res.data.data.lawyerCase
        })
      } else {
        this.getArticle(this.$route.query.id).then(() => {
          this.getLawyerList()
          this.getArticleList()
        })
      }
      // 添加右侧吸顶效果
      window.addEventListener('scroll', this.handleScroll)
      this.$nextTick(() => {
        this.offsetTop = document.querySelector('#rightFixed').getBoundingClientRect().y
      })
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
      // 获取文章内容
      async getArticle (id) {
        return new Promise(resolve => {
          api.getArticle(id).then(res => {
            this.article = res.data.data
            this.type = this.article.type
            resolve()
          })
        })
      },
      // 获取推荐律师
      getLawyerList () {
        let params = {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          expertField: this.type
        }
        api.getLawyerList(params).then(res => {
          this.lawyerList = res.data.data.list
        })
      },
      // 职位转化
      lawyerPositionFilter (data) {
        let obj = {1: '主任', 2: '副主任', 3: '执行主任', 4: '高级合伙人', 5: '合伙人', 6: '律师', 7: '其他'}
        return obj[data]
      },
      // 获取推荐文章
      getArticleList () {
        let params = {
          pageIndex: this.pageIndex,
          pageSize: 5,
          type: this.type,
          id: this.$route.query.id
        }
        api.getArticleList(params).then(res => {
          this.articleList = res.data.data.list
        })
      },
      handleScroll () {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (scrollTop >= 170) {
          this.isFixed = true
        } else {
          this.isFixed = false
        }
      }
    }
  }
</script>

<style lang='stylus' scoped>
  @import '../../styles/constant.styl'
  .article-detail {
    margin-top .72rem
    .fixed-box {
      position fixed
      top 0
      right 2.4rem
    }
    &-content {
      width: 100%
      background #f7f7f7
      &-inner {
        width: 9.6rem
        margin 0 auto
        padding-top .24rem
        &-title {
          font-size: .16rem;
          color: #1d1b1b;
          margin-bottom .48rem
          span {
            color: #a9a9a9;
          }
        }
        &-content {
          width: 100%
          display flex
          justify-content space-between
          &-left {
            width: 6.2rem
            min-height 3.5rem
            background #fff
            padding .2rem
          }
          &-right {
            width: 3rem
            background #f7f7f7
            .title {
              width: 3rem
              line-height .56rem
              display flex
              justify-content space-between
              font-size: .16rem;
              font-weight: 500;
              p {
                color: #3e3a3a;
              }
              span {
                color: #a9a9a9;
                cursor pointer
              }
              span:hover {
                color:#ed6c00
              }
            }
            .lawyer {
              .content {
                display flex
                background #fff
                margin-bottom .08rem
                &-avatar {
                  width: 1rem
                  height: 1rem
                  margin-right .1rem
                }
                &-msg {
                  color: #3e3a3a;
                  cursor pointer
                  &-title {
                    font-size: .14rem;
                    font-weight: 500;
                    line-height .32rem
                  }
                  p {
                    font-size: .12rem
                    line-height .18rem
                  }
                  .help {
                    font-size: .12rem;
                    line-height: .32rem;
                    color: #a9a9a9;
                  }
                }
              }
            }
            .article {
              .content {
                background #fff
                padding 0 .20rem
                li {
                  font-size: .14rem
                  color: #3e3a3a
                  padding .14rem 0
                  border-bottom 1px solid #f4f4f4
                  cursor: pointer
                }
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/article-detail/article-detail.vue